import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import injectSheet from 'react-jss'
import styles from '../../assets/styles/components/Dialog'
import Dialog from '../../components/hoc/Dialog'
import { bindActionCreators } from 'redux'
import * as basketAction from '../../actions/components/basket'

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = (dispatch) => {
  const { removePerItemRemark } = bindActionCreators(basketAction, dispatch)
  return {
    removePerItemRemark,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(injectSheet(styles)(Dialog))))



// WEBPACK FOOTER //
// ./src/containers/hoc/Dialog.js